module.exports = __webpack_public_path__ + "static/media/mt-ut-img-12.d1ab604b.webp";